import React from 'react';
import BaseCard from './BaseCard';

type SignatureViewProps = {
    url?: string,
    onPress?: () => void,
    clickable?: boolean
}

const SignatureView: React.FC<SignatureViewProps> = ({url, onPress = () => { }, clickable = false}) => {

    return (
        <BaseCard clickable={clickable} onPressFunc={onPress} customBaseCardStyle="rounded-3 pd-8 signature-view position-relative mg-t-10">
            <>
                {url ? <img src={url} alt="img" /> : null}
                {!url && (
                    <div className='fs-12 text-black opacity-25 d-flex align-items-center justify-content-center h-100'>Add Signature</div>
                )}
            </>
        </BaseCard>
    )

};

export default SignatureView;